<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form
            :model="model"
            :bedrijven="bedrijven"
            :glastypes="glastypes"
            :soortbelichtingen="soortbelichtingen"
            :isEditing="true"
            @save-item="updateItem">
        </item-form>

        <b-modal title="Wijzigen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Afdeling werd niet gewijzigd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/afdeling';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                bedrijven: [],
                glastypes: [],
                soortbelichtingen: [],
                model: {},
            };
        },
        created () {
            api.getDetailAfdeling(this.$route.params.id).then((response) => {
                this.bedrijven = response.data.bedrijven;
                this.glastypes = response.data.glastypes;
                this.soortbelichtingen = response.data.soortbelichtingen;
                this.model = response.data.model;
            });
        },
        methods: {
            updateItem (model) {
                api.updateAfdeling(model).then(() => {
                    this.$router.replace('/beheer/afdeling');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/afdeling/Edit.vue